module.exports = __webpack_public_path__ + "static/media/feedback-grid-preview.c356b4ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/TestimonialsLegacy/images/feedback-grid-preview.png
// module id = 5995
// module chunks = 13